"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const config_1 = require("@completeanatomy/config");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function InviteMultipleMembersButton({ buttonText, hint, groupId, }) {
    const bridge = (0, bridge_1.useBridge)();
    const configService = (0, config_1.useConfigService)();
    const goToDashboard = () => {
        try {
            const dashboardUrl = configService === null || configService === void 0 ? void 0 : configService.get('cb_dashboard_url');
            const link = groupId
                ? `${dashboardUrl}upload/${groupId}/`
                : `${dashboardUrl}groups/`;
            bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link });
        }
        catch (e) {
            console.error(e);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "$withHint": !!hint, "data-e2e": 'InviteMultipleMembersButton_Container', children: [hint && (0, jsx_runtime_1.jsx)(StyledText, { "data-e2e": 'InviteMultipleMembersButton_StyledText', children: hint }), (0, jsx_runtime_1.jsx)(StyledButton, { onClick: goToDashboard, "data-e2e": 'InviteMultipleMembersButton_StyledButton', children: buttonText })] }));
}
exports.default = InviteMultipleMembersButton;
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: left;
  align-items: center;

  margin: ${({ $withHint }) => ($withHint ? '30px 0 15px 15px' : '0 0 15px 0')};
`;
const StyledText = (0, styled_components_1.default)(ui_1.TruncatedText) `
  color: ${({ theme }) => theme.text};
  font-size: 14px;
`;
const StyledButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  padding: 15px 30px;
  font-size: 12px;
`;
